/**
 * @fileoverview 基本的な日時表記のデフォルトコンポーネント
 */
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { localeDate, localeDateJa } from '@/utilities/formatter'
import { DATETIME_FORMAT, DATE_FORMAT_JA_WITH_DAY_OF_WEEK } from '@/constants/dateFormat'

export default defineComponent({
  name: 'DateDefault',

  props: {
    /**
     * 日時の文字列
     *
     * @description YYYY-MM-DDTHH:mm:ss+09:00 の形式
     */
    date: {
      type: String,
      default: '',
    },

    /**
     * 日時のフォーマット
     *
     * @default DATE_FORMAT_JA_WITH_DAY_OF_WEEK = yyyy年M月d日(E)
     */
    format: {
      type: String,
      default: DATE_FORMAT_JA_WITH_DAY_OF_WEEK,
    },

    /**
     * 日時の接尾辞
     */
    suffix: {
      type: String,
      default: '',
    },

    /**
     * 表示フォントサイズ
     * @description small: $font-xx-small、normal: $font-x-small、large: $font-small
     */
    size: {
      type: String as PropType<'small' | 'normal' | 'large'>,
      default: 'normal',
    },

    /**
     * ラッパーサイズに収まらなかった場合に、テキストを省略するかどうか
     */
    truncated: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    return {
      // constants
      DATETIME_FORMAT,

      // methods
      localeDate,
      localeDateJa,
    }
  }
})
</script>

<template>
  <div
    class="o-label__date"
    :data-size="size"
    :data-truncated="truncated">
    <time
      class="o-label__date--item"
      :datetime="date"
      :title="localeDate(date, DATETIME_FORMAT).toString()">
      {{ localeDateJa(date, format) }}
      <span
        v-if="suffix"
        class="span u-text__block">
        {{ suffix }}
      </span>
    </time>
  <!-- /.o-label__date --></div>
</template>

<style lang="sass" scoped>
.o-label__date
  $root: &

  & &--item
    display: block
    line-height: 1
    color: $font-light-gray
    // リンク内に配置された場合は親の pointer を継承させる（テキスト選択カーソルは出さない）
    cursor: inherit

  &[data-size="small"]
    #{$root}--item
      font-size: $font-xx-small

  &[data-size="normal"]
    #{$root}--item
      font-size: $font-x-small

  &[data-size="large"]
    #{$root}--item
      font-size: $font-small

  +breakpoint
    &[data-size="large"]
      #{$root}--item
        font-size: $font-x-small

  &[data-truncated="true"]
    #{$root}--item
      white-space: nowrap
      text-overflow: ellipsis
      overflow: hidden
</style>
